import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'

interface SplitWordsProps {
    text: string
    delay?: number
    stagger?: number
}

/**
 * Splits a line into per-word masks so it can rise into place a word at a
 * time. The parent carries data-reveal="words"; the CSS does the rest.
 */
export const SplitWords: FC<SplitWordsProps> = ({
    text,
    delay = 0,
    stagger = 0.045
}): ReactNode => {
    return (
        <>
            {text.split(' ').map((word, index) => (
                <Fragment key={`${word}-${index}`}>
                    {index > 0 ? ' ' : null}

                    <span className='mo-split-w'>
                        <span
                            className='mo-split-i'
                            style={{ transitionDelay: `${(delay + index * stagger).toFixed(3)}s` }}
                        >
                            {word}
                        </span>
                    </span>
                </Fragment>
            ))}
        </>
    )
}
